import React, { useState } from 'react'
import UserDetails from 'containers/UserDetails'
import { ContainerGeral } from './Styled'

// Componentes
import BannerPrincipal from './Components/BannerPrincipal/BannerPrincipal'
import Planos from './Components/Planos/Planos'
import ListaBonus from './Components/ListaBonus/ListaBonus'
import ProgramaDeMentorias from './Components/ProgramaDeMentorias/ProgramaDeMentorias'
import DescontoProporcional from './Components/DescontoProporcional/DescontoProporcional'
import CondicaoExclusiva from './Components/CondicaoExclusiva/CondicaoExclusiva'
import Rodape from './Components/Rodape/Rodape'

export default function RenovacaoAntecipada2026 () {

	return (
		<UserDetails showSpinner>
			{details => {

				const [data] = useState(details.blackfriday)				

				let planosInitial = data.planos;

				return (
					<ContainerGeral padding={false}>
						
						{/* Banner Principal */}
						<BannerPrincipal nome={details.name} desconto={data.valor_desconto} dataFim={data.data_fim} />

						{/* Planos */}
						<Planos planos={planosInitial} desconto={data.valor_desconto} />

						{/* Lista Descontos */}
						<ListaBonus planos={planosInitial} dataFim={data.data_fim} />

						{/* Programa de Mentorias */}
						<ProgramaDeMentorias />

						{/* Desconto Proporcional */}
						<DescontoProporcional />

						{/* Condição Exclusiva */}
						<CondicaoExclusiva />

						{/* Rodapé */}
						<Rodape />
	
					</ContainerGeral>
				)
				
			}}
		</UserDetails>
	)
}
